/* istanbul ignore file */
import React from 'react';

import { canAccessContentAnalytics } from '@lumapps/content-analytics/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';
import { isReportFeatureEnabled } from '@lumapps/reports/ducks/selectors';

import {
    getCurrentContentId,
    getCurrentContentStatus,
    getCurrentCustomContentTypeId,
    contentHasContextualActions,
    isContextualActionsEnabled,
    isInDesignerMode,
} from '../../ducks/selectors';
import { LegacyContentStatus } from '../../types';
import {
    ContentContextualActions as ContentContextualActionsComponent,
    ContentContextualActionsProps,
} from './ContentContextualActions';

const ContentContextualActionsWrapper: React.FC<Partial<ContentContextualActionsProps>> = (props) => {
    const currentStatus = useSelector(getCurrentContentStatus);
    const isFFEnabled = useSelector(isContextualActionsEnabled);
    const hasContextualActions = useSelector(contentHasContextualActions);
    const isEnabled = isFFEnabled && hasContextualActions;
    const canAccessContentAnalyticsValue =
        useSelector(canAccessContentAnalytics) && currentStatus === LegacyContentStatus.live;
    const canAccessReports = useSelector(isReportFeatureEnabled) && currentStatus === LegacyContentStatus.live;
    const contentId = useSelector(getCurrentContentId)!;
    const contentTypeId = useSelector(getCurrentCustomContentTypeId);
    const isInDesignerModeValue = useSelector(isInDesignerMode);
    const isHomePage = useSelector((state: FrontOfficeStore) => state.content.isHomepage);

    return (
        <ContentContextualActionsComponent
            isEnabled={isEnabled}
            canAccessContentAnalytics={canAccessContentAnalyticsValue}
            canAccessReports={canAccessReports}
            contentId={contentId}
            contentTypeId={contentTypeId}
            isInDesignerMode={isInDesignerModeValue}
            isHomePage={isHomePage}
            {...props}
        />
    );
};

ContentContextualActionsWrapper.displayName = 'ContentContextualActions';

export { ContentContextualActionsWrapper as ContentContextualActions };
